export default __webpack_public_path__ + "static/media/red-packet-promotion.7c070083.jpg";